import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, Grid, TextField, Theme, useMediaQuery} from "@mui/material";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import LoadingProgress from "../../components/LoadingProgress";
import Strings from "../../assets/strings";
import {DateInput, TextFieldCurrency} from "../../components/CustomTextField";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {formatDate, hasPermissionTo, PERSMISOS} from "../../helpers";
import {agregarAppUserPago} from "../../redux/reducers/appUsersReducers";
import SelectBanco from "./SelectBanco";

const initialState = {
    companyId: 0,
    fecha: formatDate(new Date(),"YYYY-MM-DD"),
    cuotas: 1,
    concepto: "",
    monto: 0,
    bancoId:0,
    referencia:""
}
export default function AgregarPagoUser({open, onClose}:{open:boolean, onClose: ()=>void}) {
    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    let dispatch = useAppDispatch();
    let {byId,status} = useAppSelector(state => state.appUsers);




    const [state, setState] = useState<typeof initialState>(initialState);

    useEffect(() => {
        setState({...initialState, monto: byId?.montoCuota ?? 0})
    }, [byId, setState]);

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name, value= 0} = e.target
        if(name === "cuotas"){
            return setState({...state, [name]: +value, monto: +value * +(byId?.montoCuota ?? 0)});

        }
        setState({...state, [name]: value});

        // if(error) setError("");
    }
    const submitForm = (e:React.FormEvent<HTMLFormElement>) =>{
        e.preventDefault();
        dispatch(agregarAppUserPago({
            companyId: byId?.id,
            fecha: state.fecha,
            cuotas: +state.cuotas,
            concepto: state.concepto,
            monto: +state.monto,
            bancoId: +state.bancoId,
            referencia: state.referencia,
        })).then(v=>{
            if(v.payload){
                setState(initialState)
                onClose()
            }
        })
    }
    return (
        <Dialog fullScreen={smVewport} open={open} fullWidth maxWidth={"xs"} disableEscapeKeyDown>
            <TopBarDialog title={Strings.agregar +" "+Strings.pago} onClose={onClose} nofullScreen/>
            <DialogContent>
                {status === "loading" && <LoadingProgress vh={false} />}
                <form  id={"formPago"} onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                required
                                type={"number"}
                                name="cuotas"
                                value={state.cuotas}
                                onChange={handleChange}
                                label={Strings.cuotas}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DateInput
                                label={Strings.fecha}
                                name="fecha"
                                value={state.fecha || formatDate(new Date(),"YYYY-MM-DD")}
                                margin={"none"}
                                onChange={handleChange}
                                disabled={!hasPermissionTo(PERSMISOS.pagosCambiarFecha)} native={undefined} clearable={undefined}
                                openTo={undefined} views={undefined} quincenalFijo={undefined}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextFieldCurrency id="monto" required label={Strings.monto} fullWidth name="monto"
                                               value={state.monto??""}
                                               onChange={handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            <SelectBanco
                                name="bancoId"
                                value={state.bancoId}
                                onChange={handleChange}
                                label={"Banco"}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="referencia"
                                value={state.referencia}
                                onChange={handleChange}
                                label={Strings.referencia}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="concepto"
                                value={state.concepto}
                                onChange={handleChange}
                                label={Strings.concepto}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant={"text"} color="warning">{Strings.cancelar}</Button>
                <Button type="submit" form={"formPago"} color="primary" disabled={status === "loading"} variant={"outlined"}>
                    {Strings.guardar}
                </Button>
            </DialogActions>
        </Dialog>

    );

}
